export const userConfirmationOptions = [
  {
    label: "待客户确认",
    value: "WAIT_CONFIRM",
  },
  {
    label: "客户已确认",
    value: "SUCCESS",
  },
  {
    label: "已取消",
    value: "CANCEL",
  },
]


// WEBPACK FOOTER //
// ./src/views/user/children/contants.js